import { useTimezone } from '@app/core/hooks/useTimezone';
import { Station } from '@app/core/types/stations';
import { DateStr, toDateDiffRange, toDateStr, today } from '@mi-front/core';
import moment from 'moment-timezone';
import { apiClient } from '../../../../../../../../api';
import { ReportView } from '../../../../../../../../core/reports/components/ReportView';
import { EqualMd5ReportEmptyState } from './EqualMd5ReportEmptyState';
import { EqualMd5ReportForm } from './EqualMd5ReportForm';
import { EqualMd5ReportResult } from './EqualMd5ReportResult';
import { EqualMd5Report } from './types';

export function AuditEqualMd5ReportView(p: { station: Station }) {
  const tz = useTimezone();

  // Last 30 days inclusive (today + previous 29 days), matching date-range presets.
  const resetValues = {
    ...toDateDiffRange(
      toDateStr(moment().tz(tz).subtract(29, 'days')) as DateStr,
      today() as DateStr,
      tz,
    ),
  };

  return (
    <ReportView<EqualMd5Report>
      defaultValues={resetValues}
      download={{
        filename: 'duplicated-media',
        local: true,
        resultToExport: (result) =>
          result.items.map((item) => ({
            md5: item.md5,
            customIds: item.audios.map((a) => a.customId).join(' '),
          })),
      }}
      reportFn={(values) => {
        return apiClient.audit.stationReportsEqualMd5({
          stationId: p.station.slug,
          from: values.from,
          to: values.to,
        });
      }}
      Form={EqualMd5ReportForm}
      Result={EqualMd5ReportResult}
      emptyResult={<EqualMd5ReportEmptyState />}
    />
  );
}
